module.exports = __webpack_public_path__ + "img/48x34x72-Kit.ed76da7e.png";